export const STORY_IDS_MIME = 'application/x-arbor-story-ids';

export function setStoryIdsDragPayload(
  dataTransfer: DataTransfer,
  storyIds: string[],
): void {
  dataTransfer.setData(STORY_IDS_MIME, JSON.stringify(storyIds));
  // Provide a fallback text representation so debug tooling / accessibility
  // surfaces something readable; consumers ignore this.
  dataTransfer.setData('text/plain', `Arbor stories: ${storyIds.length}`);
  dataTransfer.effectAllowed = 'move';
}

export function readStoryIdsDragPayload(
  dataTransfer: DataTransfer,
): string[] | null {
  const raw = dataTransfer.getData(STORY_IDS_MIME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (
      Array.isArray(parsed) &&
      parsed.every((id): id is string => typeof id === 'string')
    ) {
      return parsed;
    }
  } catch {
    // fall through
  }
  return null;
}

export function dataTransferHasStoryIds(dataTransfer: DataTransfer): boolean {
  // `types` is a DOMStringList in some browsers; .includes works on the
  // ReadonlyArray representation Chrome/Safari/Firefox return.
  return Array.from(dataTransfer.types).includes(STORY_IDS_MIME);
}
